import utils from '@/../../shared/utils'

// What the live controls can do right now, from the room's game state.
// Shared by LiveDock (bottom bar) and PlaybackControls (wherever the
// transport buttons appear), so both always agree.
export default {
    computed: {
        game(){ return this.$store.state.game; },
        playback(){ return this.game.stage_playback; },
        question(){ return this.game.question ? this.game.question.question : null; },
        is_admin(){ return !!this.game.user && this.game.user.role == utils.USER_ROLES.ADMINISTRATOR; },
        is_interlude(){ return this.game.state == utils.GAME_STATES.INTERLUDE; },
        // Sector content (ranking/feedback) owns the timeline - the server
        // refuses prev/pause/next until it's done (see running_sector).
        busy(){ return !!(this.playback && this.playback.running_sector); },
        can_resume(){
            if(this.game.state == utils.GAME_STATES.PAUSED) return true;
            return !!(this.playback && !this.playback.active && !this.busy);
        },
        at_stop(){ return this.game.state == utils.GAME_STATES.PAUSED; },
        // The synchronised countdown into an activity is already running -
        // "Empezar ya" again would restart it (server re-arms the launch).
        counting_down(){
            return this.game.state == utils.GAME_STATES.TITLE && !!(this.question && this.question.start_time);
        },
        // A presentation on screen: "Siguiente"/"Anterior" turn its pages
        // first (server.js's _presentation_step).
        slides(){
            if(this.game.state != utils.GAME_STATES.CHOICES || !utils.is_presenter_slides(this.question))
                return null;
            const pages = Math.max(1, parseInt(this.question.page_count) || 1);
            return { page: Math.min(this.game.content_page || 0, pages - 1), pages };
        },
        has_previous(){
            return (!!this.slides && this.slides.page > 0) || (!!this.playback && this.playback.index > 0);
        },
        next_label(){
            const S = utils.GAME_STATES;
            switch(this.game.state){
                case S.INTERLUDE: return 'Saltar animación';
                case S.TITLE: return this.counting_down ? 'Empezando…' : 'Empezar ya';
                case S.CHOICES:
                    if(this.slides) return this.slides.page < this.slides.pages - 1 ? 'Siguiente diapositiva' : 'Siguiente actividad';
                    // A question without a clock still needs its answers closed.
                    return utils.is_manual_advance(this.question) && utils.is_content_activity(this.question.type) ? 'Siguiente' : 'Cerrar respuestas';
            }
            return 'Siguiente';
        },
        manual_activity_live(){
            return !this.playback && [utils.GAME_STATES.TITLE, utils.GAME_STATES.CHOICES].includes(this.game.state) && !!this.question;
        },
        // Without a stage playing nothing moves the room on by itself after a
        // manual launch or forced stop - this is the way out.
        can_return_to_lobby(){ return !this.playback && !this.can_resume; },
        // Anything on screen for the players besides the waiting room.
        is_live(){
            return !!this.playback || (!!this.game.state && ![utils.GAME_STATES.IDLE, utils.GAME_STATES.AUTH].includes(this.game.state));
        },
    },
    methods: {
        send_rpc(rpc, params = null){
            window.network.wso.send(JSON.stringify({ action: window.RPC[rpc], params }));
        },
    }
}
